import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-register',
  templateUrl: './fh-svg-register.component.html',
  styleUrl: './fh-svg-register.component.scss'
})
export class FhSvgRegisterComponent {
  @Input() color: string = '';
}
